// removed by extract-text-webpack-plugin
module.exports = {"dots":"Mi4TzPRdRMBbHTZ4jiFtd","dash":"_2riT21S8hiXEK8XBMY9oOf","number":"dfx1Ctag7Amyy96VPQnhK","isActive":"_3F1rx26U64kg89wYAZPWBk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DropZone/CarouselDecorator/CarouselDecorator.scss
 ** module id = 727
 ** module chunks = 0
 **/